const CATEGORY_DAYS = Object.freeze([
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday"
]);

const createEmptyCategoryState = () =>
    CATEGORY_DAYS.reduce((accumulator, day) => {
        accumulator[day] = {};
        return accumulator;
    }, {});

const cloneCategoryDay = (dayData = {}) => {
    const cloned = {};
    Object.keys(dayData).forEach((category) => {
        const selections = Array.isArray(dayData[category])
            ? [...dayData[category]]
            : [];
        cloned[category] = selections;
    });
    return cloned;
};

const cloneCategoryState = (state = {}) => {
    const cloned = createEmptyCategoryState();
    CATEGORY_DAYS.forEach((day) => {
        cloned[day] = cloneCategoryDay(state[day]);
    });
    return cloned;
};

const normalizeCategoryState = (state = {}) => {
    const normalized = createEmptyCategoryState();
    CATEGORY_DAYS.forEach((day) => {
        const source = state[day] || {};
        const normalizedDay = {};
        Object.keys(source).forEach((category) => {
            const selections = source[category];
            if (Array.isArray(selections)) {
                normalizedDay[category] = [...selections];
            }
        });
        normalized[day] = normalizedDay;
    });
    return normalized;
};

const serializeDay = (dayData = {}) => {
    const ordered = {};
    Object.keys(dayData)
        .sort()
        .forEach((category) => {
            const list = Array.isArray(dayData[category])
                ? [...dayData[category]].sort()
                : [];
            ordered[category] = list;
        });
    return JSON.stringify(ordered);
};

const areDaysUniform = (state = {}) => {
    if (CATEGORY_DAYS.length === 0) {
        return true;
    }
    const baseline = serializeDay(state[CATEGORY_DAYS[0]]);
    return CATEGORY_DAYS.every((day) => serializeDay(state[day]) === baseline);
};

const replicateStateFromDay = (state = {}, baseDay = CATEGORY_DAYS[0]) => {
    const base = cloneCategoryDay(state[baseDay]);
    const replicated = createEmptyCategoryState();
    CATEGORY_DAYS.forEach((day) => {
        replicated[day] = cloneCategoryDay(base);
    });
    return replicated;
};

const formatDayLabel = (day) => `${day.charAt(0).toUpperCase()}${day.slice(1)}`;

export {
    CATEGORY_DAYS,
    createEmptyCategoryState,
    cloneCategoryState,
    normalizeCategoryState,
    areDaysUniform,
    replicateStateFromDay,
    formatDayLabel
};
